"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * SVB Labels
 * All these properties are properties  of props
 * @param versionValues: used to render values for version dropdown
 * @param labelType: type of Label
 * @param labelText: text used to display label
 * @param showCircle: to show circle next to the tag
 * @param subLabelType: used to decide status label type
 * @param endPointType: used to decide end point type
 * @param categoryType: used to decide category type
 * @returns HTML tag with content
 */

const labelMappings = {
  "versioning-large": "svb-label_versioning large svb-label_versioning-dropdown",
  "versioning-medium": "svb-label_versioning medium",
  "versioning-small": "svb-label_versioning",
  "status-label-deprecated": "svb-label_status_status-deprecated",
  "status-label-beta": "svb-label_status_status-beta",
  "status-label-active": "svb-label_status_status-active",
  "status-label-early-adopter": "svb-label_status_status-early-adopter",
  "svb-label-active-two": "svb-label_status_status-active-two",
  "endpoint_type-get": "svb-label_endpoint_type-get",
  "endpoint_type-post": "svb-label_endpoint_type-post",
  "endpoint_type-patch": "svb-label_endpoint_type-patch",
  "endpoint_type-delete": "svb-label_endpoint_type-delete",
  "case-study": "svb-label_category-tag_type-case-study",
  "use-case": "svb-label_category-tag_type-use-case",
  api: "svb-label_category-tag_type-api",
  faq: "svb-label_category-tag_type-faq",
  product: "svb-label_category-tag_type-product",
  version: "svb-label_category-tag_type-version",
  resource: "svb-label_category-tag_type-resource",
  new: "svb-label_category-tag_type-new",
  tag: "svb-label_category-tag_type-tag-change",
  "content-edits": "svb-label_category-tag_type-content-edits"
};
const SVBLabels = props => {
  const versionValues = props.versionValues || [];
  const labelType = props.labelType || "";
  const labelText = props.labelText || "";
  const subLabelType = props.subLabelType || "";
  const endpointType = props.endPointType || "";
  const categoryType = props.categoryType || "";
  const showCircle = props.showCircle || "";
  const onPress = props.onPress;
  const value = props.value || "";
  const extraClasses = props.extraClasses || "";
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, labelType === "versioning-large" && /*#__PURE__*/_react.default.createElement("select", {
    key: "versioningDropdown",
    type: "button",
    value: value,
    onChange: event => onPress(event.target.value),
    placeholder: "selected Version",
    className: labelMappings[labelType] + " ".concat(extraClasses)
  }, (versionValues === null || versionValues === void 0 ? void 0 : versionValues[0]) && versionValues.map((val, i) => {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: "option" + i
    }, val);
  })), (labelType === "versioning-medium" || labelType === "versioning-small") && /*#__PURE__*/_react.default.createElement("span", {
    className: labelMappings[labelType] + " ".concat(extraClasses)
  }, labelText), labelType === "status-labels-large" && /*#__PURE__*/_react.default.createElement("span", {
    className: "svb-label_status svb-label_status_size-large " + labelMappings[subLabelType] + " ".concat(extraClasses)
  }, showCircle && /*#__PURE__*/_react.default.createElement("span", {
    className: "label-circle"
  }), labelText), labelType === "status-labels-small" && /*#__PURE__*/_react.default.createElement("span", {
    className: "svb-label_status svb-label_status_size-small " + labelMappings[subLabelType] + " ".concat(extraClasses)
  }, labelText), labelType === "endpoint-labels-standard" && /*#__PURE__*/_react.default.createElement("span", {
    className: "svb-label_endpoint svb-label_endpoint_size-standard " + labelMappings[endpointType] + " ".concat(extraClasses)
  }, labelText), labelType === "endpoint-labels-standard-outline" && /*#__PURE__*/_react.default.createElement("span", {
    className: "svb-label_endpoint svb-label_endpoint_size-standard svb-label_endpoint_outline " + labelMappings[endpointType] + " ".concat(extraClasses)
  }, labelText), labelType === "endpoint-labels-small" && /*#__PURE__*/_react.default.createElement("span", {
    className: "svb-label_endpoint svb-label_endpoint_size-small " + labelMappings[endpointType] + " ".concat(extraClasses)
  }, labelText), labelType === "endpoint-labels-small-outline" && /*#__PURE__*/_react.default.createElement("span", {
    className: "svb-label_endpoint svb-label_endpoint_size-small svb-label_endpoint_outline " + labelMappings[endpointType] + " ".concat(extraClasses)
  }, labelText), labelType === "categories-labels" && /*#__PURE__*/_react.default.createElement("span", {
    className: "svb-label_category-tag " + labelMappings[categoryType] + " ".concat(extraClasses)
  }, labelText));
};
var _default = SVBLabels;
exports.default = _default;